import { RouteComponentProps } from '@reach/router';
import { ManagementPanelBordereau } from '../ManagementPanel/pages/dashboard/Bordereau';

interface VagoAdminActionsProps extends RouteComponentProps {}
export const VagoAdminActions = (_props: VagoAdminActionsProps) => {
  return (
    <>
      <h1>VaGo Admin Actions</h1>
      <ManagementPanelBordereau />
    </>
  );
};
